import React from 'react'
import { mount } from 'enzyme'
import ProductSwitchReasons from '../features/product/ProductSwitchReasons'

describe('<ProductSwitchReasons />', () => {
  let wrapper, props
  const noop = () => {}
  beforeEach(() => {
    props = {
      productSwitchReasons: [
        { description: 'test 1', key: 'test1' },
        { description: 'abc1', key: 'abc2' },
        { description: 'zkwd222', key: 'zkwd222' }
      ],
      onReasonCheck: noop,
      onNoteChange: noop
    }
    wrapper = mount(<ProductSwitchReasons {...props} />)
  })
  it('should return something', () => {
    expect(ProductSwitchReasons(props)).toBeTruthy()
  })
  it('should render a checkbox input for each provided reason', () => {
    expect(wrapper.find('input')).toHaveLength(props.productSwitchReasons.length)
  })
  it('should call its onReasonCheck prop when a reason is checked', () => {
    wrapper.setProps({ onReasonCheck: jest.fn() })
    const reason = wrapper.find('input').at(0)
    reason.simulate('change', {})
    expect(wrapper.prop('onReasonCheck')).toHaveBeenCalledTimes(1)
  })
  it('should call its onNoteChange prop when the user enters a note', () => {
    wrapper.setProps({ onNoteChange: jest.fn() })
    const textarea = wrapper.find('textarea')
    textarea.simulate('change', {})
    expect(wrapper.prop('onNoteChange')).toHaveBeenCalledTimes(1)
  })
  it('should order the reasons alphabetically', () => {
    expect(wrapper.find('label').at(0).text()).toBe('abc1')
  })
})
